module.exports = __webpack_public_path__ + "36134a68f5eae87055371a9a8678a2b4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/View_Results_Icon.png
// module id = 0qvT
// module chunks = 17